import TrainingProgressFactory from './TrainingProgressTag'
import TrainingProgessToolbar from './TrainingProgressToolbar'

module.exports = (modules)->
  {React,Icon,textedit_utils,CollapsePanel,reducers,SharedReducers,slate} = modules
  TrainingProgressTag = TrainingProgressFactory(modules)
     
  # what name to use, should be unique
  name:"TrainingProgress"

  tags:{"trainingprogress"}

  # html to insert from drag and drop
  drophtml:'<training-progress></training-progress>'
  
  # What to render in the toolbar when element is selected
  toolbar:TrainingProgessToolbar(modules)
  
  # what icon to show in media elements
  icon:(props)-> 
    <React.Fragment>
      <div style={{border:"1px solid rgba(255.255.255.0.1)",width:48,height:35,margin:"0 auto",position:"relative"}}>
        <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="m17.66 55.359c-1.4648 0.0625-2.8945-0.47266-3.9531-1.4883-1.0586-1.0156-1.6602-2.418-1.6602-3.8867 0-1.4648 0.60156-2.8711 1.6602-3.8828 1.0586-1.0156 2.4883-1.5547 3.9531-1.4922h26.941c1.4648-0.0625 2.8906 0.47656 3.9531 1.4922 1.0586 1.0117 1.6562 2.418 1.6562 3.8828 0 1.4688-0.59766 2.8711-1.6562 3.8867-1.0625 1.0156-2.4883 1.5508-3.9531 1.4883zm64.68-16.109h-64.68c-5.9375 0-10.75 4.8125-10.75 10.75s4.8125 10.75 10.75 10.75h64.68c5.9375 0 10.75-4.8125 10.75-10.75s-4.8125-10.75-10.75-10.75z" fill-rule="evenodd"/>
        </svg>
      </div>
      <span className="label">Training Progress</span>
    </React.Fragment>

  plugins:[{ 
    schema:
      blocks:
        trainingprogress:
          isVoid: true
  }]
  
  # convert AST to HTML
  serialize:(object, children)->
    if object.type == "trainingprogress"
      return <training-progress path={object.data.get("path")}></training-progress>

  # convert HTML to AST
  deserialize:(el,next)->
    return if el.tagName?.toLowerCase()!="training-progress"
    attributes = textedit_utils.attributesFromElement(el)
    {
      object: 'block',
      type: "trainingprogress",
      isVoid: true,
      data: attributes
    }
  
  # convert AST to inpage editing component
  renderNode:({attributes, children, node, isSelected, editor} )->
    return if node.type!="trainingprogress"
    attributes.style = {} if !attributes.style
    # attributes = Object.assign({},attributes,{className:node.data.toObject().className})
    props = node.data.toObject()
    <TrainingProgressTag attributes={attributes} props={props} node={node} isSelected={isSelected} editor={editor} name={@name}></TrainingProgressTag>